<h1 mat-dialog-title>Share Interactive</h1>
<div mat-dialog-content>
  <app-share-editor
    allowReadOnly="true"
    allowModify="true"
    [(ngModel)]="data.shareState"
    [avaialbleSubscriptions]="data.userSubscriptions"
  ></app-share-editor>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    class="piButton"
    (click)="onConfirmClick()"
    cdkFocusInitial
  >
    Confirm
  </button>
  <button mat-raised-button class="piButton" (click)="onCancelClick()">
    Cancel
  </button>
</div>
